import React from 'react';
import { connect } from 'react-redux';
import { deleteTugasAllStudentAnswer } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteTugasAllStudentAnswer,
};

function ModalDeleteAllStudentAnswer({
  data,
  deleteTugasAllStudentAnswer,
  closeModal,
}) {
  const { auth, history, item } = data;

  function onDelete() {
    deleteTugasAllStudentAnswer(auth, history, item.tugasId);
    closeModal();
  }
  return (
    <Modal variant='danger' closeModal={closeModal}>
      <p className='my-3 mx-1'>
        Apakah Anda yakin ingin menghapus tugas yang disubmit siswa?
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={onDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteAllStudentAnswer);
